(() => {
  const BASE = 'https://assets.calendly.com/assets/external/widget';
  let loading = null;

  const load = () => {
    if (window.Calendly) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = `${BASE}.css`;
      document.head.append(css);
      const js = document.createElement('script');
      js.src = `${BASE}.js`;
      js.async = true;
      js.onload = () => (window.Calendly ? resolve() : reject());
      js.onerror = reject;
      document.head.append(js);
    }).catch((error) => {
      loading = null;
      throw error;
    });
    return loading;
  };

  const popupUrl = (href) => {
    const url = new URL(href);
    url.searchParams.set('hide_gdpr_banner', '1');
    const primary = getComputedStyle(document.documentElement).getPropertyValue('--md-seed').trim();
    if (/^#[0-9a-f]{6}$/i.test(primary)) url.searchParams.set('primary_color', primary.slice(1));
    return url.toString();
  };

  const warm = (event) => {
    if (event.target.closest?.('[data-md-booking-calendly]')) load().catch(() => {});
  };

  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-md-booking-calendly]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    load()
      .then(() => window.Calendly.initPopupWidget({ url: popupUrl(link.href) }))
      .catch(() => window.open(link.href, '_blank', 'noopener'))
      .finally(() => link.removeAttribute('aria-busy'));
  });
})();
